import React from 'react'

import CheckBoxElement, { type CheckBoxElementProps } from './checkbox-element'

export type CheckBoxInputProps = CheckBoxElementProps

// a transparent native checkbox filling its Box
const CheckBoxInput = (props: CheckBoxInputProps) => (
  <CheckBoxElement {...props} />
)

export default CheckBoxInput
